module.exports = parseInt(require("eslint/package.json").version, 10);
